import * as React from 'react';
import { useState } from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  
  const [formSubmitted, setFormSubmitted] = useState(false);
  
  const   handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Replace these with your actual EmailJS credentials
    // TODO: Move these to environment variables before deploying
    const SERVICE_ID = "service_1bn9xxt";  // Replace with your Service ID
    const TEMPLATE_ID = "template_rkh7dtn"; // Replace with your Template ID
    const PUBLIC_KEY = "s21wtmv0hTJG9XzQv";   // Replace with your Public Key
    
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      from_phone: formData.phone,
      subject: formData.subject,
      message: formData.message,
      to_email: 'preferindustries@gmail.com'
    };

    toast.promise(
      emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY),
      {
        pending: 'Sending message...',
        success: 'Message sent successfully! 👍',
        error: 'Failed to send message. Please try again 🤯'
      },
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      }
    ).then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        setFormSubmitted(true);
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: '',
        });
      })
      .catch((err) => {
        console.log('FAILED...', err);
      });

    setTimeout(() => {
      setFormSubmitted(false);
    }, 5000);
  };

  return (
    <div className="contact-page">
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {/* Page Header */}
      <div className="page-headerContact">
        <div className="container">
          <h1>Contact Us</h1>
          <p>Get in touch with our team for inquiries and quotes</p>
        </div>
      </div>
      
      {/* Contact Information */}
      <section className="section contact-info-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info-box">
              <div className="info-icon">
                <FaPhoneAlt />
              </div>
              <h3>Phone</h3>
              <p>(+91)9911966848</p>
              {/* <p>(555) 987-6543</p> */}
            </div>
            
            <div className="contact-info-box">
              <div className="info-icon">
                <FaEnvelope />
              </div>
              <h3>Email</h3>
              <p>preferindustries@gmail.com</p>
              {/* <p>support@preferbuild.com</p> */}
            </div>
            
            <div className="contact-info-box">
              <div className="info-icon">
                <FaMapMarkerAlt />
              </div>
              <h3>Office Address</h3>
              <p>Ghaziabad</p>
              <p>Uttar Pradesh, India</p>
            </div>
            
            <div className="contact-info-box">
              <div className="info-icon">
                <FaClock />
              </div>
              <h3>Working Hours</h3>
              <p>Monday - Friday: 8am - 6pm</p>
              <p>Saturday: 9am - 2pm</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Contact Form */}
      <section className="section contact-form-section">
        <div className="container">
          <div className="contact-form-container">
            <div className="form-header">
              <h2 className="section-title">Get a Free Quote</h2>
              <p>
                Fill out the form below with your project details, and our team will get back to you with a free estimate. We're committed to providing timely and informative responses to all inquiries.
              </p>
            </div>
            
            {formSubmitted ? (
              <div className="form-success">
                <h3>Thank You!</h3>
                <p>Your message has been sent successfully. We'll get back to you shortly.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Your Name*</label>
                    <input 
                      type="text" 
                      id="name" 
                      name="name" 
                      required 
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Your Full Name"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="email">Your Email*</label>
                    <input 
                      type="email" 
                      id="email" 
                      name="email" 
                      required
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Dummy@gmail.com"
                    />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number*</label>
                    <input 
                      type="tel" 
                      id="phone" 
                      name="phone"
                      required
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="(+91) 1234567"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="subject">Subject*</label>
                    <input 
                      type="text" 
                      id="subject" 
                      name="subject" 
                      required
                      value={formData.subject}
                      onChange={handleChange}
                      placeholder="Project Inquiry"
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Your Message*</label>
                  <textarea 
                    id="message" 
                    name="message" 
                    rows="6" 
                    required
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="
                    Give us a brief description of your enquiry."
                  ></textarea>
                </div>
                
                <div className="form-submit">
                  <button type="submit" className="btn">Send Message</button>
                </div>
              </form>
            )}
          </div>
        </div>
      </section>
      
      {/* Map Section */}
<section className="map-section">
  <div className="map-container">
    <iframe
      className="google-map"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d142078.656161327!2d77.05479863585096!3d28.52617453119845!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd5b347eb62d%3A0x52c2b7494e204dce!2sNew%20Delhi%2C%20Delhi!5e1!3m2!1sen!2sin!4v1754137921783!5m2!1sen!2sin"
      width="100%"
      height="400"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
  </div>
</section>
    </div>
  );
};

export default Contact;
